import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
//import GitHub from "@material-ui/icons/GitHub";
//import YouTube from "@material-ui/icons/YouTube";
//import Email from "@material-ui/icons/Email";



const useStyles = makeStyles({
  bottomNavContainer: {
    background: "#222",
    height: "55px",
    overflow: "hidden",
  },
  root: {
    "& .MuiSvgIcon-root": {
      fill: "tan",
      "&:hover": {
        fill: "tomato",
        fontSize: "1.8rem",
      },
    },
  },
});

const Footer = () => {
  const classes = useStyles();
  return (
    <BottomNavigation className={classes.bottomNavContainer}>
      <BottomNavigationAction
        showLabel
        label="© Avery Lockwood"
        className={classes.root}
      />
    </BottomNavigation>
  );
};
export default Footer;
